<template>
  <div>
    <p class="upgrade_big">Are you sure you want to delete?</p>

    <p>
      If you delete a video, it's permanently deleted — you can't recover it.
    </p>

    <button
        class="color_btn hover_op"
        @click="
        removeVideo(
          $store.state.record_remove_id        )
      "
    >
      Yes, remove
    </button>

    <button
        class="transparent_btn hover_op"
        @click="$store.commit('hideModal')"
    >
      No, keep it
    </button>
  </div>
</template>

<script>
import Axios from "axios";

export default {
  methods: {
    async removeVideo(id) {
      try {
        await this.$store.dispatch("deleteMeeting", id)
        this.$store.commit("hideModal");
        this.$store.dispatch("onSuccess", "Recording deleted");
        this.$router.push("/user_rooms")
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },
  },
};
</script>

<style>
</style>
